import { render, staticRenderFns } from "./ThreeEDITOR.vue?vue&type=template&id=1d99c57f&scoped=true&slot-scope=scope&"
import script from "./ThreeEDITOR.vue?vue&type=script&lang=js&"
export * from "./ThreeEDITOR.vue?vue&type=script&lang=js&"
import style0 from "./ThreeEDITOR.vue?vue&type=style&index=0&id=1d99c57f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d99c57f",
  null
  
)

export default component.exports